import { localizedPath, PublicLocale } from './locales';
export interface BlogSummary {
  id: string;
  slug: string;
  title: string;
  sourceUrl: string;
  publishedAt: string;
  excerpt: string;
  image?: string;
  author?: string;
  contentLocale?: string;
}
export interface BlogPost extends BlogSummary {
  html: string;
  /** Feed publication time stays stable; this changes only when the article body changes. */
  updatedAt?: string;
}
export const BLOG_TITLE = 'Bible study articles | Revelationary';
export const BLOG_DESCRIPTION =
  'Explore articles about scripture and bring your questions to the Revelationary Bible study community.';
export const articlePath = (slug: string) => `/blog/${slug}/`;
export const articleDate = (date: string, locale = 'en-GB') =>
  new Date(date).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
export function articleSchema(post: BlogPost, locale: PublicLocale = 'en') {
  const url = `https://revelationary.online${localizedPath(articlePath(post.slug), locale)}`;
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    '@id': `${url}#article`,
    url,
    mainEntityOfPage: url,
    headline: post.title,
    description: post.excerpt,
    datePublished: post.publishedAt,
    dateModified: post.updatedAt ?? post.publishedAt,
    ...(post.image ? { image: post.image } : {}),
    ...(post.author ? { author: { '@type': 'Person', name: post.author } } : {}),
    publisher: {
      '@type': 'Organization',
      name: 'Revelationary',
      url: 'https://revelationary.online/',
    },
  };
}

/** Read a date we placed on structured data, without trusting arbitrary objects. */
export function articleTime(
  schema: object | undefined,
  key: 'datePublished' | 'dateModified',
): string | undefined {
  if (!schema || !Object.hasOwn(schema, key)) {
    return undefined;
  }
  const value = Object.getOwnPropertyDescriptor(schema, key)?.value;
  return typeof value === 'string' && value ? value : undefined;
}
